import {
    CreditCardOutlined,
    DashboardOutlined,
    FileDoneOutlined,
    FileOutlined,
    PieChartOutlined,
    RetweetOutlined,
    TeamOutlined,
    UserAddOutlined,
    UsergroupAddOutlined,
    UserOutlined,
    VideoCameraOutlined,
} from '@ant-design/icons';
import {Menu} from 'antd';
import React, {forwardRef, useContext, useEffect, useImperativeHandle, useState} from 'react';
import "./style.scss";
import userAccessService from "../../../service/UserAccessService";
import {Link} from "react-router-dom";
import {SystemSettingContext} from "../../../context/SystemContext";
import {FileTextOutlined} from "@ant-design/icons/lib";
import SubMenu from "antd/es/menu/SubMenu";
import {MenuDto} from "../../../dto/MenuDto";
import {
    bookmarks_img,
    joint_acc_requests_img,
    joint_template_side_menu_img,
    requests_side_menu_img,
    trans_img
} from "../../../../AppImageConst";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRightArrowLeft, faListCheck, faMoneyBillWave, faSliders} from "@fortawesome/free-solid-svg-icons";


// function getItem(
//     label: React.ReactNode,
//     key: React.Key,
//     icon?: React.ReactNode,
//     children?: MenuItem[],
//     type?: 'group',
// ): MenuItem {
//     return {
//         key,
//         icon,
//         children,
//         label,
//         type,
//     } as MenuItem;
// }

const initItems: MenuDto[] = [];

const SideBarComp = forwardRef((props: any, ref) => {


    const [items, setMenuItem] = useState<MenuDto[]>(initItems);
    const [isError, setError] = useState<boolean>(false);
    const {systemSetting, setSystemSetting} = useContext(SystemSettingContext);
    // useEffect(() => {
    //     let mounted = true;
    //     userAccessService.getSideMenuList().then(res => {
    //         setError(false);
    //         if (mounted) {
    //             let menuItemList: MenuItem[] = [];
    //             let menuFormDto: MenuFormDto = res.data;
    //             menuFormDto.menuItemDtoList.map((menuItem, i) => {
    //                 let subMenuItemList: MenuItem[] = [];
    //                 menuItem.subMenuItems.map((subMenu, j) => {
    //                     subMenuItemList.push(getItem(
    //                         <Link to={subMenu.appUrl} className="nav-link">
    //                             <span className={"ant-menu-title-content"}>{subMenu.menuName}</span>
    //                         </Link>
    //                         , 'sub' + i + '' + j));
    //                 });
    //                 menuItemList.push(getItem(menuItem.menuName, 'main' + i,
    //                     getIcon(menuItem.menuIcon), subMenuItemList));
    //
    //             })
    //             setMenuItem(menuItemList);
    //         }
    //     }).catch((reason) => {
    //         console.log("ERROR : ", reason);
    //         setError(true);
    //     })
    //     return function cleanup() {
    //         mounted = false;
    //     }
    // }, [items.length > 0]);

    useEffect(() => {
        let mounted = true;
        userAccessService.getSideMenuList().then(res => {
            setError(false);
            if (mounted) {
                let menuItemDtoList = res.data.menuItemDtoList;
                setMenuItem(menuItemDtoList);
                checkSelectedSideMenu(menuItemDtoList)
            }

        }).catch((reason) => {
            setError(true);
        })
        return function cleanup() {
            mounted = false;
        }
    }, []);
    useImperativeHandle(ref, () => ({
        selectDashboard() {
            checkSelectedSideMenu(items)

        },
    }));

    const onClick = (e: any) => {
        let keys: Array<string> = [];
        keys.push(e.keyPath[1]);
        keys.push(e.keyPath[0]);
        setSystemSetting({...systemSetting, selectedMenuKey: keys})
    };

    const getIcon = (iconName: string) => {
        switch (iconName) {
            case "FileTextOutlined": {
                return <FileTextOutlined/>
            }
            case "VideoCameraOutlined": {
                return <VideoCameraOutlined/>
            }
            case "UserOutlined": {
                return <UserOutlined/>
            }
            case "DashboardOutlined": {
                return <DashboardOutlined/>
            }
            case "UserAddOutlined": {
                return <UserAddOutlined/> //Individual Account Requests - Admin account
            }
            case "UsergroupAddOutlined": {
                return <UsergroupAddOutlined/> // Joint Account Requests - Customer account
            }
            case "FileOutlined": {
                return <FileOutlined/>
            }
            case "FileDoneOutlined": {
                return <FileDoneOutlined/>
            }
            case "faMoneyBillTransfer": {
                return <CreditCardOutlined/>
            }
            case "TeamOutlined": {
                return <TeamOutlined/>
            }
            case "RetweetOutlined": {
                return <RetweetOutlined/>
            }
            case "faSliders": {
                return <FontAwesomeIcon icon={faSliders}/>
            }
            case "faMoneyBillWave": {
                return <FontAwesomeIcon icon={faMoneyBillWave}/>
            }
            case "faAdminTransactions": {
                return <FontAwesomeIcon icon={faArrowRightArrowLeft}/>
            }
            case "faListCheck": {
                return <FontAwesomeIcon icon={faListCheck}/>
            }
            //Change Requests - Customer account
            case "ChangeRequests": {
                return <img className='side-menu-icon-img' src={requests_side_menu_img}/>
            }
            //Joint account template requests - Customer account
            case "JointAccountTemplateRequest": {
                return <img className='joint-template-side-menu-icon-img' src={joint_template_side_menu_img}/>
            }
            //Joint account requests - Customer account
            case "JointAccountRequests": {
                return <img className='joint_acc_requests_img' src={joint_acc_requests_img}/>
            }
            //All Transactions
            case "AllTransactions": {
                return <img className='side-menu-icon-img' src={trans_img}/>
            }
            case "ThirdPartyBankTemplates": {
                return <img className='side-menu-icon-img' src={bookmarks_img}/>
            }
            default: {
                return <PieChartOutlined/>
            }
        }
    }

    const checkSelectedSideMenu = (menuItems: MenuDto[]) => {
        // let find = menuItems.find(item => currentUrl.includes(item.appUrl));

        menuItems.forEach(menuItem => {
            let findMenu = window.location.href.includes(menuItem.appUrl);
            if (findMenu) {
                setSystemSetting({...systemSetting, selectedMenuKey: [menuItem.id]})
                return;
            } else {
                menuItem.subMenuItems.forEach(subMenu => {
                    findMenu = window.location.href.includes(subMenu.appUrl);
                    if (findMenu) {
                        setSystemSetting({...systemSetting, selectedMenuKey: [subMenu.id]})
                        return;
                    }
                })
            }
        })
    }


    return !isError ? (
        items.length > 0 ?
            <Menu
                onClick={onClick}
                defaultSelectedKeys={systemSetting.selectedMenuKey}
                mode="inline"
                theme="light"
                className='side-menu'
                selectedKeys={systemSetting.selectedMenuKey}
                // items={items}
            >
                {items.map((menuItemDto, index) => (
                    menuItemDto.subMenuItems.length > 0 ?
                        <SubMenu key={menuItemDto.id} icon={getIcon(menuItemDto.menuIcon)}
                                 title={menuItemDto.menuName}
                                 style={{margin: '0px 0px'}}>
                            {
                                menuItemDto.subMenuItems.map((subMenuItemDto, subIndex) => (
                                    <Menu.Item key={subMenuItemDto.id}
                                        // style={{whiteSpace: 'normal', height: 'auto' ,marginBottom: '22px'}}
                                    >
                                        <Link to={subMenuItemDto.appUrl}
                                              className="nav-link">{subMenuItemDto.menuName}</Link>

                                    </Menu.Item>
                                ))
                            }

                        </SubMenu> :
                        <Menu.Item key={menuItemDto.id} icon={getIcon(menuItemDto.menuIcon)}>
                            {menuItemDto.externalUrl ?
                                <a href={menuItemDto.appUrl} target="_blank"
                                   rel="noopener noreferrer">{menuItemDto.menuName} </a>
                                :
                                <Link to={menuItemDto.appUrl} className="nav-link">{menuItemDto.menuName}</Link>}
                        </Menu.Item>
                ))}
            </Menu> : ''
    ) : (<div>503 Service Unavailable</div>);
});
export default SideBarComp;
